import {EpLayer} from "./layer";
import {devicesStyle, farDevicesStyle} from "../styles/devices";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";
import {pointerStyle} from "../styles/pointer";

export class EpPointerLayer extends EpLayer {

    constructor(map) {
        super(map);
        this.style = pointerStyle;
        return this;
    }

    addToMapFromCoordinates(coordinates, options = {}) {
        options = {...{ resize: false }, ...options};

        let feature = new Feature({
            geometry: new Point(fromLonLat(coordinates.split(","))),
            zoomLimit: 13.5,
            type: 'pointer',
            changed: false
        });
        this.getSource().addFeature(feature);

        if(options.resize) {
            this.fitInView();
        }
    }

}
